import * as Sentry from '@sentry/browser';
import { ExtraErrorData } from '@sentry/integrations';

/**
 * SentryWrapper
 *
 * Very simple object that wraps
 * Sentry and errors if it can't be initialised
 *
 * Sentry by default will not capture
 * errors  if a DSN isn't passed to it
 * and we don't want iframes to accidentally
 * be doing this
 */

function SentryWrapper({
  sentryDSN,
  parentPageUrl,
}: {
  sentryDSN?: string;
  parentPageUrl?: string;
}): typeof Sentry {
  if (!(sentryDSN || onLocalhost())) {
    throw new Error('Could not initialise Sentry');
  }

  return {
    ...Sentry,

    init() {
      Sentry.init({
        dsn: sentryDSN,
        initialScope: (scope) => {
          if (parentPageUrl) {
            scope.setExtra('parentPageUrl', parentPageUrl);
          }
          return scope;
        },
        integrations: [
          new ExtraErrorData({
            depth: 10,
          }),
        ],
        denyUrls: [
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          /^chrome-extension:\/\//i,
        ],
      });
    },
  };
}

function onLocalhost() {
  return (
    window.location.host.includes('localhost') ||
    window.location.host.includes('ngrok')
  );
}

export default SentryWrapper;
